import util from "@/mixins/util";
import {localStorageKey} from "@/api/config";

function encodeBase64(data) {
    let encodedString = btoa(data);
    return encodedString;
}

function decodeBase64(codeString) {
    let decodedString = atob(codeString);
    return decodedString;
}


class LevelClass {
    level = {}
    checkHasLevelObj() {
        return util.isEmpty(this.level);
    }
    setterLevel(data) {
        this.level = data;
        let objString = JSON.stringify(data);
        let encodedData = encodeBase64(objString);
        window.localStorage.setItem(localStorageKey+'level', encodedData);
    }
    getterLevel() {
        let codeString =  window.localStorage.getItem(localStorageKey+'level');
        if(!util.isEmpty(codeString)) {
            let levelString = decodeBase64(codeString);
            this.level = JSON.parse(levelString);
        }
        return this.level;
    }
}

export {LevelClass};
